var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "rentabilidade", attrs: { fluid: "" } },
    [
      _vm.loading || _vm.emErro
        ? _c(
            "div",
            { staticClass: "d-flex justify-center align-center pa-4" },
            [
              _vm.loading
                ? _c("v-progress-circular", {
                    attrs: { size: 35, color: "primary", indeterminate: "" }
                  })
                : _vm._e(),
              _vm.emErro
                ? _c(
                    "div",
                    { staticStyle: { color: "red", "font-weight": "bold" } },
                    [_vm._v(_vm._s(this.errorMessage))]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c("div", { ref: "tabs", staticClass: "tabs" }, [
        _c(
          "div",
          {
            staticClass: "tab active",
            attrs: { id: "rentabilidade" },
            on: {
              click: function($event) {
                return _vm.changeTab("rentabilidade", $event)
              }
            }
          },
          [_c("span", { staticClass: "title-tab" }, [_vm._v("Rentabilidade")])]
        ),
        _c(
          "div",
          {
            staticClass: "tab",
            attrs: { id: "resultadoFinanceiro" },
            on: {
              click: function($event) {
                return _vm.changeTab("resultadoFinanceiro", $event)
              }
            }
          },
          [
            _c("span", { staticClass: "title-tab" }, [
              _vm._v("Resultado Financeiro")
            ])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "tab",
            attrs: { id: "atribuicaoEstrategia" },
            on: {
              click: function($event) {
                return _vm.changeTab("atribuicaoEstrategia", $event)
              }
            }
          },
          [
            _c("span", { staticClass: "title-tab" }, [
              _vm._v("Atribuição por estratégia")
            ])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "tab",
            attrs: { id: "alocacaoTotal" },
            on: {
              click: function($event) {
                return _vm.changeTab("alocacaoTotal", $event)
              }
            }
          },
          [_c("span", { staticClass: "title-tab" }, [_vm._v("Alocação Total")])]
        ),
        _c(
          "div",
          {
            staticClass: "tab",
            attrs: { id: "desempenhoCarteira" },
            on: {
              click: function($event) {
                return _vm.changeTab("desempenhoCarteira", $event)
              }
            }
          },
          [
            _c("span", { staticClass: "title-tab" }, [
              _vm._v("Desempenho por carteira")
            ])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "tab",
            attrs: { id: "Custodiante" },
            on: {
              click: function($event) {
                return _vm.changeTab("Custodiante", $event)
              }
            }
          },
          [_c("span", { staticClass: "title-tab" }, [_vm._v("Custodiante")])]
        )
      ]),
      _c(
        "div",
        { staticClass: "telas" },
        [
          _c(_vm.currentView, {
            tag: "component",
            attrs: { calculos: _vm.calculos, dozeMeses: _vm.dozeMeses }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }